import {deleteUser} from "../auth/Auth";

export const getRequest = async (endpoint) => {
    const response = await fetch(endpoint, {
        method: 'GET'
    });
    checkUserLoginStatus(response);
    return {data: JSON.parse(await response.text()), status: response.status};
};

export const postRequest = async (values) => {
    const response = await fetch(values.endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': values.token ? values.token : null
        },
        body: JSON.stringify(values),
    });
    if (!values.endpoint.includes("auth/token")) {
        checkUserLoginStatus(response);
    }
    return {data: JSON.parse(await response.text()), status: response.status};
};

export const uploadFile = async (data, endpoint, values) => {
    const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Authorization': values && values.token ? values.token : null,
        },
        body: data,
    });
    checkUserLoginStatus(response);
    return {data: JSON.parse(await response.text()), status: response.status};
};

export const downloadFile = async (endpoint, token) => {
    const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
            'Authorization': token
        },
    });
    checkUserLoginStatus(response);
    return {
        data: await response,
        status: response.status,
        text: response.status !== 200 ? JSON.parse(await response.text()) : null
    };
};

const checkUserLoginStatus = (response) => {
    if (response.status === 401) {
        deleteUser().then(() => {
            window.location.href = '/login';
        });
    }
}
